import axios from 'axios';
import get from 'lodash.get';
import { from } from 'rxjs';
import type { Observable } from 'rxjs';

import { emptyArray } from 'ui-components/default-props/empty';
import type { SellerRecommendation } from './seller-recommendation';

export const getSellerRecommendations = (): Observable<SellerRecommendation[]> => {
  const request = axios.get('/seller/recommendations').then((response) => {
    const recommendations = get(response, 'data.recommendations');
    return Array.isArray(recommendations) ? recommendations : (emptyArray as SellerRecommendation[]);
  });

  return from(request);
};

export const markRecommendationDismissed = (recommendationType: string, maxDismissalCount: number): Observable<{ success: boolean }> => {
  const request = axios
    .post(`/seller/recommendations/${encodeURIComponent(recommendationType)}/dismissed`, { maxDismissalCount })
    .then((response) => {
      return get(response, 'data', { success: false });
    })
    .catch(() => ({ success: false }));

  return from(request);
};

export const markRecommendationActioned = (recommendationType: string): Observable<{ success: boolean }> => {
  const request = axios
    .post(`/seller/recommendations/${encodeURIComponent(recommendationType)}/actioned`)
    .then((response) => {
      return get(response, 'data', { success: false });
    })
    .catch(() => ({ success: false }));

  return from(request);
};
